<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent timeWidth">
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item style="width: 100px">
              <el-select
                v-model="listMenuForm.selectValue"
                placeholder="请选择"
                style="width: 100px !important;"
              >
                <el-option label="暱稱" value="0"></el-option>
                <el-option label="賬號" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="searchItem">
              <el-input v-model="listMenuForm.nikeName"></el-input>
            </el-form-item>

            <el-form-item label="評論狀態">
              <el-select v-model="listMenuForm.status" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="置頂" value="5"></el-option>
                <el-option label="已刪除" value="0"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="熱評狀態">
              <el-select v-model="listMenuForm.hotStatus" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="熱評" value="2"></el-option>
                <el-option label="鎖定" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否隱藏">
              <el-select
                v-model="listMenuForm.hide"
                placeholder="请选择"
                @change="hidechange"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="未隱藏" value="1"></el-option>
                <el-option label="隱藏" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="隱藏選項"
              v-if="!fromDiary && listMenuForm.hide == 2"
              class="searchItem hidden-lg-and-down"
            >
              <el-select
                v-model="listMenuForm.feedbackStatus"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="黑名单" value="1"></el-option>
                <el-option label="违规" value="2"></el-option>
                <el-option label="敏感字符" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="評論時間"
              class="searchItem hidden-lg-and-down"
              v-if="!fromDiary"
            >
              <el-date-picker
                v-model="listMenuForm.timeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm  hidden-xl-only"
          >
            <el-form-item
              label="隱藏選項"
              v-if="!fromDiary && listMenuForm.hide == 2"
              class="searchItem"
            >
              <el-select
                v-model="listMenuForm.feedbackStatus"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="黑名单" value="1"></el-option>
                <el-option label="违规" value="2"></el-option>
                <el-option label="敏感字符" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="評論時間" class="searchItem">
              <el-date-picker
                v-model="listMenuForm.timeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap">
        <div class="btn" @click="addMsg()" v-if="!fromDiary">新增回復</div>
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table
          :data="newsComList"
          style="width:100%;"
          @selection-change="handleSelectionChange"
          ref="commentTable"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column type="selection" :selectable="selectInit" width="55">
          </el-table-column>
          <el-table-column prop="nickName" label="用戶暱稱"> </el-table-column>
          <el-table-column prop="email" label="用戶賬號"> </el-table-column>
          <el-table-column prop="comTime" label="評論時間"> </el-table-column>
          <el-table-column prop="content" label="評論內容" width="300">
            <template slot-scope="scope">
              <div>
                <span
                  :class="
                    scope.row.complainStatus === '置頂'
                      ? 'font-color-purple'
                      : ''
                  "
                  >{{ scope.row.content }}</span
                >
              </div>
              <div v-if="scope.row.userComment !== null">
                <span class="font-color-29">回復：</span
                ><span
                  >{{ scope.row.userNickName }}：{{
                    scope.row.userComment
                  }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="like" label="評論點讚數">
            <template slot-scope="scope">
              <div v-if="scope.row.feedbackStatus == '已刪除'">
                -
              </div>
              <div v-else>
                <span>{{ scope.row.like }}</span>
                <i
                  v-if="scope.row.complainStatus !== '置頂'"
                  @click="changeCommentNum(scope.row)"
                  class="el-icon-edit"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="熱評數">
            <template slot-scope="scope">
              <div v-if="scope.row.feedbackStatus == '已刪除'">
                -
              </div>
              <div v-else>
                <span>{{ scope.row.score }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="狀態" width="120">
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.complainStatus === '置頂' ? 'font-color-purple' : ''
                "
                >{{ scope.row.feedbackStatus }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="heatStatus" label="熱評狀態">
          </el-table-column>
          <el-table-column prop="hide" label="是否隐藏" width="70">
            <template slot-scope="scope">
              <div v-if="scope.row.feedbackStatus == '已刪除'">
                -
              </div>
              <div v-else>
                <span>{{ scope.row.hide }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="熱評操作" fixed="right" :width="130">
            <template slot-scope="scope">
              <el-button
                @click="setHotComment(scope.row, 1)"
                type="text"
                :disabled="
                  scope.row.hide === '隱藏' ||
                    scope.row.complainStatus === '置頂'
                "
              >
                設為熱評
              </el-button>
              <el-button
                @click="setHotComment(scope.row, 2)"
                type="text"
                :disabled="
                  scope.row.heatStatus === '鎖定' ||
                    scope.row.hide === '隱藏' ||
                    scope.row.complainStatus === '置頂'
                "
              >
                降權
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="普通操作" fixed="right" :width="200">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.heatStatus !== '鎖定'"
                @click="lockedComment(scope.row, 1)"
                type="text"
                :disabled="
                  scope.row.hide === '隱藏' ||
                    scope.row.complainStatus === '置頂' ||
                    scope.row.feedbackStatus === '已刪除'
                "
              >
                鎖定
              </el-button>
              <el-button
                v-else-if="scope.row.heatStatus === '鎖定'"
                @click="lockedComment(scope.row, 0)"
                type="text"
                :disabled="
                  scope.row.hide === '隱藏' ||
                    scope.row.complainStatus === '置頂' ||
                    scope.row.feedbackStatus === '已刪除'
                "
              >
                取消鎖定
              </el-button>
              <el-button
                :disabled="scope.row.feedbackStatus === '已刪除'"
                v-if="
                  scope.row.complainStatus === '置頂' &&
                    !fromDiary &&
                    scope.row.hide === '未隱藏'
                "
                type="text"
                @click="editComment(scope.row)"
                >编辑
              </el-button>
              <el-button
                :disabled="scope.row.feedbackStatus === '已刪除'"
                v-if="
                  scope.row.complainStatus === '正常' &&
                    !fromDiary &&
                    scope.row.hide === '未隱藏'
                "
                type="text"
                @click="replyUser(scope.row)"
                >回复
              </el-button>
              <el-button
                @click="cancelHideComment(scope.row)"
                type="text"
                v-if="scope.row.hide === '隱藏'"
                :disabled="
                  scope.row.feedbackStatus === '違規' ||
                    scope.row.feedbackStatus === '黑名單' ||
                    scope.row.feedbackStatus === '已刪除'
                "
                key="autoButton"
              >
                取消隱藏
              </el-button>
              <el-button
                @click="hideComment(scope.row)"
                type="text"
                :disabled="
                  scope.row.heatStatus === '鎖定' ||
                    scope.row.feedbackStatus === '已刪除'
                "
                v-else
                >隱藏
              </el-button>
              <el-button
                :disabled="scope.row.feedbackStatus === '已刪除'"
                @click="delComment(scope.row)"
                type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-operation">
        <div class="left-operation">
          <div class="el-table-column--selection">
            <div class="cell" style="width: 55px">
              <label class="el-checkbox">
                <span
                  aria-checked="mixed"
                  class="el-checkbox__input"
                  :class="selectStatus === 1 ? 'is-focus is-checked' : ''"
                  @click="selectAll"
                >
                  <span class="el-checkbox__inner"></span>
                </span>
              </label>
            </div>
          </div>
          <span class="font-color-29">全選</span>
        </div>
        <div class="right-operation">
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : ''"
            @click="hideComment('delselected')"
          >
            批量隐藏
          </div>
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : ''"
            @click="cancelHideComment('delselected')"
          >
            批量取消隐藏
          </div>
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : 'bg-delete-btn'"
            @click="delComment('delselected')"
          >
            刪除
          </div>
        </div>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="currentPageSize"
          :pager-count="5"
          :page-sizes="[20, 50, 100]"
          layout="prev,sizes, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
    <!-- 降權 -->
    <div v-if="downHotFlag" class="propWrap">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">提示信息</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="cancelDownHot"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <div class="el-message-box__message" style="margin-bottom:0.2rem;">
            <p>{{ addNoticetips }}</p>
          </div>
          <el-form>
            <el-form-item label="設定係數：">
              <el-radio-group v-model="checkDownNum">
                <div
                  v-for="(item, index) in downNumArray"
                  :key="index"
                  style="margin-bottom:0.05rem;"
                >
                  <el-radio :label="item.num">
                    {{ item.name }}
                  </el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="備註：">
              <el-input
                type="textarea"
                autosize
                placeholder="請輸入備註（選填）"
                maxLength="200"
                v-model="downHotReason"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-message-box__btns">
          <button
            @click="cancelDownHot"
            type="button"
            class="el-button el-button--default el-button--small"
          >
            <span>取消</span>
          </button>
          <button
            @click="downHotComment"
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>降權</span>
          </button>
        </div>
      </div>
    </div>
    <!--新增回复-->
    <div class="dialog-wrap-style" v-if="replyNewVisible">
      <div class="dialog_common_style">
        <div class="dialog_header">
          <div class="dialog_title">
            新增回復
          </div>
          <div class="dialog_content">
            <p>{{ reply.replyUserName }}：{{ reply.replyUserContent }}</p>
            <p>{{ reply.replyUserTime }}</p>
          </div>
        </div>
        <div class="divider"></div>
        <div class="dialog_body">
          <div class="dialog_tip">回復该留言</div>
          <textarea
            class="dialog_text"
            v-model="addCommentContent"
            placeholder="給JM們說說悄悄話吧～"
          />
          <div class="dialog_btn">
            <el-button type="primary" @click="replyComment" :loading="isClick"
              >{{ isClick ? "回復中" : "回復" }}
            </el-button>
            <div class="btn borderBtn btn_font" @click="beforeClose">取消</div>
          </div>
        </div>
      </div>
    </div>
    <!--新增留言-->
    <div class="dialog-wrap-style" v-if="addNewVisible">
      <div class="dialog_common_style">
        <div class="dialog_header">
          <div class="dialog_title">
            新增留言
          </div>
        </div>
        <div class="divider"></div>
        <div class="dialog_body">
          <div class="dialog_tip">留言内容</div>
          <textarea
            class="dialog_text"
            v-model="addCommentContent"
            placeholder="給JM們說說悄悄話吧～"
          />
          <div class="dialog_btn">
            <el-button type="primary" @click="addComment" :loading="isClick">{{
              isClick ? "評論中" : "評論"
            }}</el-button>
            <div class="btn borderBtn btn_font" @click="beforeClose">取消</div>
          </div>
        </div>
      </div>
    </div>
    <!--编辑留言-->
    <div class="dialog-wrap-style" v-if="editNewVisible">
      <div class="dialog_common_style">
        <div class="dialog_header">
          <div class="dialog_title">
            編輯留言
          </div>
        </div>
        <div class="divider"></div>
        <div class="dialog_body">
          <div class="dialog_tip">留言内容</div>
          <textarea
            class="dialog_text"
            v-model="addCommentContent"
            placeholder="給JM們說說悄悄話吧～"
          />
          <div class="dialog_btn">
            <el-button type="primary" @click="ensureEdit" :loading="isClick">{{
              isClick ? "編輯中" : "確定"
            }}</el-button>
            <div class="btn borderBtn btn_font" @click="beforeClose">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import Dialog from "../../../components/dialog";
import {
  getUserStatus,
  getUserStatusCode,
  getStatusHide
} from "../../../utils/getUserStatus";

export default {
  data() {
    return {
      navBlock: "新聞  /  Wayne",
      navtitle: "查看評論",
      listMenuForm: {
        timeArr: [],
        nikeName: "",
        selectValue: "0",
        status: "",
        hotStatus: "",
        hide: "",
        feedbackStatus: ""
      },
      id: this.$route.query.id,
      newsComList: [],
      total: 50,
      currentPage: 1,
      currentPageSize: 20,
      checkAll: false, // 全選
      isIndeterminate: true,
      delId: "",
      hideId: "",
      reply: {
        replyUserName: "",
        replyUserContent: "",
        replyUserTime: "",
        replyId: ""
      },
      editId: "",
      dialogVisible: false,
      addNewVisible: false,
      replyNewVisible: false,
      editNewVisible: false,
      addCommentContent: "",
      fromDiary: false,
      selectStatus: 0,
      selectDisable: 0,
      isClick: false,
      // 降權
      downHotFlag: false,
      addNoticetips: "",
      checkDownNum: "0.6",
      downHotReason: "",
      downNumArray: [
        { name: "0.8（輕度）", num: "0.8" },
        { name: "0.6（中度）", num: "0.6" },
        { name: "0.4（明顯）", num: "0.4" },
        { name: "0（不參與熱評）", num: "0" }
      ],
      commentId: ""
    };
  },
  created() {
    let _this = this;
    _this.fromDiary = _this.$route.query.fromPage === "diary";
    if (!_this.fromDiary) {
      _this.navBlock = "新聞  /  新聞列表";
    } else {
      _this.navBlock = "新聞  /  Wayne";
    }
    _this.initList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 评论列表
    initList() {
      let _this = this;
      _this.selectDisable = 0;
      let param = {
        id: _this.id,
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        startTime:
          _this.listMenuForm.timeArr.length === 0
            ? ""
            : _this.$formatDate(_this.listMenuForm.timeArr[0]),
        endTime:
          _this.listMenuForm.timeArr.length === 0
            ? ""
            : _this
                .$formatDate(_this.listMenuForm.timeArr[1])
                .substring(0, 10) + " 23:59:59",
        nickName:
          _this.listMenuForm.selectValue === "1"
            ? ""
            : _this.listMenuForm.nikeName,
        email:
          _this.listMenuForm.selectValue === "0"
            ? ""
            : _this.listMenuForm.nikeName,
        status: _this.listMenuForm.status
          ? Number(_this.listMenuForm.status)
          : "",
        hide: _this.listMenuForm.hide ? Number(_this.listMenuForm.hide) : "",
        feedbackStatus: _this.listMenuForm.feedbackStatus
          ? Number(_this.listMenuForm.feedbackStatus)
          : "",
        heatStatus: _this.listMenuForm.hotStatus
          ? Number(_this.listMenuForm.hotStatus)
          : ""
      };
      _this
        .$post("request/newCom/getNewComyList", param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          // console.log(res)
          if (res.code === "00000") {
            res.data.list.forEach(v => {
              v.comTime = _this.$getTime(v.comTime);
              v.complainStatus = getUserStatusCode(v.complainStatus);
              v.feedbackStatus = getStatusHide(v.feedbackStatus);
              v.hide = v.isHide === 1 ? "未隱藏" : "隱藏";
              v.heatStatus =
                v.heatStatus === 1
                  ? "正常"
                  : v.heatStatus === 2
                  ? "熱評"
                  : v.heatStatus === 3
                  ? "鎖定"
                  : "-";
            });
            res.data.list.forEach(v => {
              if (v.complainStatus === "置頂") {
                _this.selectDisable++;
              }
            });
            _this.total = res.data.allRow;
            _this.newsComList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    handleSelectionChange(val) {
      let _this = this;
      let idArr = [];
      _this.hideId = [];
      if (val.length !== 0) {
        for (var i in val) {
          idArr.push(val[i].id);
          let temp = {};
          temp["id"] = val[i].id;
          temp["status"] = getUserStatus(val[i].complainStatus);
          _this.hideId.push(temp);
        }
      }
      _this.delId = idArr.join(",");
      if (val.length === 0) {
        this.selectStatus = 0;
      } else if (val.length === this.newsComList.length - this.selectDisable) {
        this.selectStatus = 1;
      } else {
        this.selectStatus = 2;
      }
    },

    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.initList();
    },

    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.initList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        timeArr: [],
        endTime: "",
        nikeName: "",
        selectValue: "0",
        status: "",
        hide: ""
      };
      _this.currentPage = 1;
      _this.initList();
    },

    // 新增回復
    addMsg() {
      this.addNewVisible = true;
    },

    // 搜索评论
    search() {
      let _this = this;
      if (
        _this.listMenuForm.timeArr.length === 0 &&
        _this.listMenuForm.nikeName === "" &&
        _this.listMenuForm.account === ""
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.$compareTime(_this.listMenuForm.timeArr[1], new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("結束時間不可以是未來時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.currentPage = 1;
      _this.initList();
    },

    // 隐藏评论
    hideComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要隱藏的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          _this
            .$confirm(
              `確認批量隱藏${_this.hideId.length}條評論，評論隱藏後將不在移動端與Web端展示！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              console.log(_this.delId);
              _this
                .$post(
                  `/request/newCom/hide/comment`,
                  _this.hideId,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量隱藏評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
        }
      } else {
        _this
          .$confirm("是否隱藏該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            let params = [
              {
                id: row.id,
                status: getUserStatus(row.complainStatus)
              }
            ];
            _this
              .$post(
                `/request/newCom/hide/comment`,
                params,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("隱藏成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 批量取消隐藏评论
    cancelHideComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要取消隱藏的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          _this
            .$confirm(
              `確認批量取消隱藏${_this.hideId.length}條評論，評論取消隱藏後將在移動端與Web端重新展示！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              console.log(_this.delId);
              _this
                .$post(
                  `/request/newCom/cancel/hide/comment`,
                  _this.hideId,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  console.log(res);
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量取消隐藏評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
        }
      } else {
        _this
          .$confirm("是否取消隱藏該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            let params = [
              {
                id: row.id,
                status: getUserStatus(row.complainStatus)
              }
            ];
            _this
              .$post(
                `/request/newCom/cancel/hide/comment`,
                params,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("取消隐藏成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 删除评论
    delComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要刪除的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          _this
            .$confirm(
              `確認批量刪除${_this.hideId.length}條評論，評論刪除後不可恢復！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              console.log(_this.delId);
              _this
                .$post(
                  `/request/newCom/deleteListComm/${_this.delId}/${_this.id}`,
                  {},
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量删除評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
        }
      } else {
        _this
          .$confirm("是否刪除該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            // 确认删除的回调
            let status = getUserStatus(row.complainStatus);
            _this
              .$post(
                `/request/newCom/deleteComm/${row.id}/${_this.id}/${status}`,
                {},
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("删除成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 编辑评论
    editComment(row) {
      this.addCommentContent = row.content;
      this.editId = row.id;
      this.editNewVisible = true;
    },

    // 回复评论
    replyUser(row) {
      this.reply.replyUserName = row.nickName;
      this.reply.replyUserContent = row.content;
      this.reply.replyUserTime = row.comTime;
      this.reply.replyId = row.id;
      this.replyNewVisible = true;
    },

    selectInit(row, index) {
      return row.complainStatus !== "置頂";
    },

    // 确认添加留言内容
    addComment() {
      var _this = this;
      if (_this.addCommentContent === "") {
        _this.dialogVisible = true;
        _this.$propMessage("评论内容不能为空", "error", function() {
          _this.dialogVisible = false;
        });
      } else {
        let params = {
          articleId: _this.id,
          leavingNew: _this.addCommentContent
        };

        if (!_this.isClick) {
          _this.isClick = true;
          _this
            .$post(
              "/request/newCom/leaving/message",
              params,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.addNewVisible = false;
                _this.$propMessage("留言成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.initList();
                  _this.addCommentContent = "";
                  _this.isClick = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                  _this.isClick = false;
                });
              }
            });
        }
      }
    },

    // 确认回复评论内容
    replyComment() {
      var _this = this;
      if (_this.addCommentContent === "") {
        _this.dialogVisible = true;
        _this.$propMessage("回复内容不能为空", "error", function() {
          _this.dialogVisible = false;
        });
      } else {
        let params = {
          articleId: _this.id,
          commentId: _this.reply.replyId,
          leavingNew: _this.addCommentContent
        };
        if (!_this.isClick) {
          _this.isClick = true;
          _this
            .$post(
              "/request/newCom/leaving/message",
              params,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.replyNewVisible = false;
                _this.$propMessage("回复成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.initList();
                  _this.addCommentContent = "";
                  _this.isClick = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                  _this.isClick = false;
                });
              }
            });
        }
      }
    },

    // 确认编辑
    ensureEdit() {
      let _this = this;
      if (this.addCommentContent === "") {
        _this.dialogVisible = true;
        _this.$propMessage("留言内容不能为空", "error", function() {
          _this.dialogVisible = false;
        });
      } else {
        let params = {
          id: this.editId,
          leavingNew: this.addCommentContent
        };
        if (!_this.isClick) {
          _this.isClick = true;
          _this
            .$post(
              "/request/newCom/update/leaving/message",
              params,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.editNewVisible = false;
                _this.$propMessage("编辑成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.initList();
                  _this.addCommentContent = "";
                  _this.isClick = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                  _this.isClick = false;
                });
              }
            });
        }
      }
    },

    selectAll() {
      if (this.selectStatus === 0 || this.selectStatus === 2) {
        this.$refs.commentTable.toggleAllSelection();
        this.selectStatus = 1;
      } else {
        this.$refs.commentTable.clearSelection();
        this.selectStatus = 0;
      }
    },

    beforeClose() {
      this.addNewVisible = false;
      this.editNewVisible = false;
      this.replyNewVisible = false;
      this.addCommentContent = "";
    },
    hidechange() {
      if (this.listMenuForm.hide != "2") {
        this.listMenuForm.feedbackStatus = "";
      }
    },
    // 修改評論數
    changeCommentNum(row) {
      this.$prompt("修改評論點讚數：", "", {
        inputValue: row.like,
        inputPlaceholder: "請輸入評論點讚數",
        confirmButtonText: "修改",
        cancelButtonText: "取消",
        showClose: false,
        center: false,
        closeOnClickModal: false,
        inputValidator: value => {
          if (!/^\d*$/.test(value)) {
            return "評論點讚數只能為純數字，且不能為負數";
          }
        }
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        if (!value) {
          this.$message({
            message: "請輸入評論點讚數",
            type: "error",
            center: true
          });
          return;
        }
        if (value > 999999) {
          this.$message({
            message: "評論點讚數不能大於999999",
            type: "error",
            center: true
          });
          return;
        }
        let params = {
          id: row.id,
          articleId: this.id,
          likeNum: value
        };
        this.$post(
          "/request/newCom/modify/feedback/like",
          params,
          this.$GLOBAL.jsonConfig
        ).then(res => {
          // console.log(res)
          if (res.code === "00000") {
            this.$message({
              message: "修改成功",
              type: "success",
              center: true
            });
            this.initList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
              center: true
            });
          }
        });
      });
    },
    // 鎖定/取消锁定評論
    lockedComment(row, type) {
      if (type === 1) {
        this.$confirm(
          `是否鎖定 "${row.content}" 這條評論？評論鎖定後，不受不喜歡、人工降權、檢舉操作等影響。`,
          "提示",
          {
            confirmButtonText: "鎖定",
            center: true,
            showClose: false,
            closeOnClickModal: false
          }
        ).then(() => {
          let params = {
            id: row.id,
            articleId: this.id,
            type: type
          };
          this.$post(
            "/request/newCom/feedback/lock/operation",
            params,
            this.$GLOBAL.jsonConfig
          ).then(res => {
            // console.log(res)
            if (res.code === "00000") {
              this.$message({
                message: "鎖定成功",
                type: "success",
                center: true
              });
              this.initList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
                center: true
              });
            }
          });
        });
      } else {
        let params = {
          id: row.id,
          articleId: this.id,
          type: type
        };
        this.$post(
          "/request/newCom/feedback/lock/operation",
          params,
          this.$GLOBAL.jsonConfig
        ).then(res => {
          // console.log(res)
          if (res.code === "00000") {
            this.$message({
              message: "取消鎖定成功",
              type: "success",
              center: true
            });
            this.initList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
              center: true
            });
            this.initList();
          }
        });
      }
    },
    // 熱評
    setHotComment(row, type) {
      this.commentId = row.id;
      if (row.remark) {
        this.downHotReason = row.remark;
      }
      if (type === 1) {
        this.$confirm(`是否將 "${row.content}" 這條評論設為熱評？`, "提示", {
          confirmButtonText: "設為熱評",
          center: true,
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          let params = {
            id: row.id,
            articleId: this.id,
            type: type,
            manualCoefficient: "1.5"
          };
          this.$post(
            "/request/newCom/hot/feedback/operation",
            params,
            this.$GLOBAL.jsonConfig
          ).then(res => {
            // console.log(res)
            if (res.code === "00000") {
              this.$message({
                message: "設置成功",
                type: "success",
                center: true
              });
              this.initList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
                center: true
              });
            }
          });
        });
      } else {
        this.downHotFlag = true;
        this.addNoticetips = `是否將 "${row.content}" 這條評論降低熱度？`;
      }
    },
    // 降權
    downHotComment() {
      if (!this.checkDownNum) {
        this.$message({
          message: "請選擇設定係數",
          type: "error",
          center: true
        });
        this.cancelDownHot();
        return;
      }
      let params = {
        id: this.commentId,
        articleId: this.id,
        type: 2,
        manualCoefficient: this.checkDownNum,
        remark: this.downHotReason
      };
      this.$post(
        "/request/newCom/hot/feedback/operation",
        params,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        // console.log(res);
        this.cancelDownHot();
        if (res.code === "00000") {
          this.$message({
            message: "降權成功",
            type: "success",
            center: true
          });
          this.initList();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            center: true
          });
        }
      });
    },
    cancelDownHot() {
      this.downHotFlag = false;
      this.checkDownNum = "0.6";
      this.downHotReason = "";
    }
  },
  components: {
    Dialog,
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
  line-height: 36px;
}

.el-range-editor.el-input__inner {
  padding-top: 0;
  padding-bottom: 0;
}

.el-table__header-wrapper .el-checkbox {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/news/viewComment.vue